/* Stick Snak purchase controls — pack radios, subscribe toggle, qty stepper.
   Works inside Horizon's <product-form-component>; this script only keeps the
   hidden variant id / selling_plan / displayed prices in sync. */
(function () {
  function formatMoney(cents, format) {
    const value = cents / 100;
    const amount = (key) => {
      switch (key) {
        case 'amount_no_decimals':
          return Math.round(value).toLocaleString('en-US');
        case 'amount_with_comma_separator':
          return value.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        case 'amount_no_decimals_with_comma_separator':
          return Math.round(value).toLocaleString('nl-NL');
        default:
          return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    };
    return (format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => amount(k));
  }

  function initBuy(root) {
    if (root.dataset.ssInit) return;
    root.dataset.ssInit = '1';

    const moneyFormat = root.dataset.moneyFormat;
    const variantInput = root.querySelector('input[name="id"]');
    const packs = Array.from(root.querySelectorAll('input[name="ss-pack"]'));
    const planInput = root.querySelector('[data-ss-selling-plan-input]');
    const modeBtns = Array.from(root.querySelectorAll('[data-ss-mode]'));
    const qtyInput = root.querySelector('.ss-buy__qty-input');
    const totalEl = root.querySelector('[data-ss-total]');

    let subscribing = modeBtns.some((btn) => btn.dataset.ssMode === 'subscribe' && btn.getAttribute('aria-pressed') === 'true');
    const shortcut = root.querySelector('[data-ss-mobile-buy]');
    const packSelector = root.querySelector('.ss-buy__packs');
    const addButton = root.querySelector('button[name="add"]');
    const params = new URLSearchParams(window.location.search);
    // A Shopify variant URL takes precedence over the friendly pack URL.
    const requestedVariant = params.get('variant');
    const variantPack = packs.find((input) => input.value === requestedVariant && !input.disabled);
    if (variantPack) variantPack.checked = true;

    // Keep previously shared trial/pack URLs useful after the pack-size update.
    const requestedPack = ({ '3': '5', '9': '10' })[params.get('pack')] || params.get('pack');
    if (requestedPack && !variantPack) {
      const requestedInput = packs.find((input) => input.dataset.units === requestedPack && !input.disabled);
      if (requestedInput) requestedInput.checked = true;
    }

    if (planInput && packs.some((pack) => pack.checked && pack.dataset.planId === params.get('selling_plan'))) subscribing = true;
    if (qtyInput && params.has('quantity')) qtyInput.value = Math.min(20, Math.max(1, Math.trunc(Number(params.get('quantity')) || 1)));

    const money = (cents) => formatMoney(cents, moneyFormat);

    function selectedPack() {
      return packs.find((p) => p.checked) || packs[0];
    }

    function update() {
      const pack = selectedPack();
      if (!pack) return;
      if (variantInput) variantInput.value = pack.value;
      modeBtns.forEach((btn) => {
        const active = (btn.dataset.ssMode === 'subscribe') === subscribing;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
      });

      packs.forEach((input) => {
        const label = input.closest('.ss-buy__pack');
        if (label) label.classList.toggle('is-selected', input.checked);
        const price = Number(input.dataset.price);
        const subPrice = Number(input.dataset.subPrice || input.dataset.price);
        const now = label && label.querySelector('[data-ss-pack-price]');
        const was = label && label.querySelector('[data-ss-pack-was]');
        const meta = label && label.querySelector('[data-ss-pack-meta]');
        const active = subscribing ? subPrice : price;
        if (now) now.textContent = money(active);
        if (was) was.hidden = !(subscribing && subPrice < price);
        if (meta) {
          const units = Math.max(1, Number(input.dataset.units) || 1);
          const unitPrice = Math.round(active / units);
          const unitsLabel = units === 1 ? meta.dataset.oneUnitLabel : meta.dataset.unitsLabel;
          meta.textContent = meta.dataset.compact === 'true'
            ? `${money(unitPrice)}${meta.dataset.unitSuffix}`
            : `${unitsLabel} · ${money(unitPrice)}${meta.dataset.unitSuffix}`;
        }
      });

      if (planInput) {
        planInput.value = subscribing ? pack.dataset.planId : '';
        planInput.disabled = !subscribing;
      }
      const purchasable = !pack.disabled && (!subscribing || Boolean(pack.dataset.planId));
      if (addButton) addButton.disabled = !purchasable;

      const qty = Math.min(20, Math.max(1, Math.trunc(Number(qtyInput && qtyInput.value) || 1)));
      const unit = subscribing ? Number(pack.dataset.subPrice || pack.dataset.price) : Number(pack.dataset.price);
      if (totalEl) totalEl.textContent = money(unit * qty);
      if (shortcut) {
        shortcut.querySelector('[data-ss-shortcut-pack]').textContent = `${qty} × ${pack.closest('label').querySelector('.ss-buy__pack-title').textContent.trim()}`;
        const mode = modeBtns.find((btn) => btn.getAttribute('aria-pressed') === 'true');
        shortcut.querySelector('[data-ss-shortcut-mode]').textContent = mode ? mode.querySelector('.ss-buy__mode-title').textContent : '';
        shortcut.querySelector('[data-ss-shortcut-total]').textContent = money(unit * qty);
      }
    }

    function rememberSelection() {
      if (packSelector?.id !== 'pack-selector') return;
      const pack = selectedPack();
      if (!pack) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', pack.value);
      url.searchParams.set('pack', pack.dataset.units);
      url.searchParams.set('quantity', qtyInput?.value || '1');
      if (subscribing && pack.dataset.planId) url.searchParams.set('selling_plan', pack.dataset.planId);
      else url.searchParams.delete('selling_plan');
      window.history.replaceState(window.history.state, '', url);
    }
    root.addEventListener('change', rememberSelection);
    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-ss-mode], [data-ss-qty]')) rememberSelection();
    });

    packs.forEach((p) => p.addEventListener('change', update));

    modeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        subscribing = btn.dataset.ssMode === 'subscribe';
        update();
      });
    });

    root.querySelectorAll('[data-ss-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const next = (Number(qtyInput.value) || 1) + Number(btn.dataset.ssQty);
        qtyInput.value = Math.min(20, Math.max(1, next));
        update();
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', update);
      qtyInput.addEventListener('change', () => {
        qtyInput.value = Math.min(20, Math.max(1, Math.trunc(Number(qtyInput.value) || 1)));
        update();
      });
    }

    if (shortcut && addButton) {
      const mobile = window.matchMedia('(max-width: 749px)');
      const syncShortcut = () => {
        const rect = addButton.getBoundingClientRect();
        const headerBottom = document.querySelector('header-component')?.getBoundingClientRect().bottom || 0;
        shortcut.hidden = !mobile.matches || (rect.top >= Math.max(0, headerBottom) && rect.bottom <= window.innerHeight - 90);
      };
      const observer = new IntersectionObserver(syncShortcut, { threshold: [0, 1], rootMargin: '0px 0px -90px 0px' });
      observer.observe(addButton);
      window.addEventListener('scroll', syncShortcut, { passive: true });
      window.addEventListener('resize', syncShortcut, { passive: true });
      const shortcutButton = root.querySelector('[data-ss-purchase-shortcut]');
      const syncShortcutAvailability = () => {
        shortcutButton.disabled = addButton.disabled;
      };
      const availabilityObserver = new MutationObserver(syncShortcutAvailability);
      availabilityObserver.observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
      shortcutButton.addEventListener('click', () => {
        if (!addButton.disabled) addButton.click();
      });
      syncShortcutAvailability();
      syncShortcut();
    }

    update();
  }

  function initAll() {
    document.querySelectorAll('product-form-component.ss-buy').forEach(initBuy);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
